import { ReactComponent as FilterDefaultIcon } from 'src/assets/svg/file/icon_coupon_map_filter_default.svg'
import { ReactComponent as FilterActiveIcon } from 'src/assets/svg/file/icon_coupon_map_filter_active.svg'
import { ReactComponent as ArrowBackIcon } from 'src/assets/svg/file/icon_coupon_map_arrow_back.svg'
import { ReactComponent as CurrentPositionIcon } from 'src/assets/svg/file/icon_coupon_map_current_position.svg'
import { ReactComponent as WasteBasketIcon } from 'src/assets/svg/file/icon_coupon_map_wasteBasket.svg'
import { ReactComponent as NotiIcon } from 'src/assets/svg/file/icon_noti.svg'
import { ReactComponent as NotiRedIcon } from 'src/assets/svg/file/icon_noti_red.svg'
import { ReactComponent as ShareIcon } from 'src/assets/svg/file/icon_share.svg'
import { ReactComponent as PlusCircleIcon } from 'src/assets/svg/file/icon_plus_circle.svg'

import React, { CSSProperties } from 'react'

type ArrowRotateType = 'right' | 'left' | 'top' | 'bottom'

const Arrow = (props: {
  color: string
  rotate: 'right' | 'left' | 'top' | 'bottom'
  size: '16' | '24'
  style?: CSSProperties
  onClickFn?: any
}) => {
  const { color, rotate, onClickFn, size, style } = props

  const rotateCovertToNumber: { [key in ArrowRotateType]: number } = {
    right: 0,
    bottom: 90,
    top: 270,
    left: 180,
  }

  const size16 = size === '16'

  const svgStyle = {
    ...style,
    width: 'fit-content',
    rotate: `${rotateCovertToNumber[rotate]}deg`,
  }
  return (
    <span style={svgStyle} onClick={onClickFn}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        cursor="pointer"
      >
        <path
          d={size16 ? 'M6 2.34326L11.6569 8.00012L6 13.657' : 'M13 3L3.80761 12.1924L13 21.3848'}
          stroke={color as string}
          strokeWidth={size16 ? '1.6' : '2.4'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

const Search = (props: { style?: CSSProperties; onClickFn: any }) => {
  const { style, onClickFn } = props
  return (
    <span style={style} onClick={onClickFn}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        cursor="pointer"
      >
        <circle cx="10.5" cy="10.5" r="7.8" stroke="white" strokeWidth="2.4" />
        <path d="M21.1999 21.2L16.7 16.7" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
    </span>
  )
}

const FillRoundCancle = (props: { style?: CSSProperties; onClickFn: any }) => {
  const { style, onClickFn } = props
  return (
    <span style={style} onClick={onClickFn}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.625 16.32L12 12.945L15.375 16.32L16.32 15.375L12.945 12L16.32 8.625L15.375 7.68L12 11.055L8.625 7.68L7.68 8.625L11.055 12L7.68 15.375L8.625 16.32ZM12 21C10.77 21 9.6075 20.7638 8.5125 20.2913C7.4175 19.8188 6.46125 19.1737 5.64375 18.3563C4.82625 17.5388 4.18125 16.5825 3.70875 15.4875C3.23625 14.3925 3 13.23 3 12C3 10.755 3.23625 9.585 3.70875 8.49C4.18125 7.395 4.82625 6.4425 5.64375 5.6325C6.46125 4.8225 7.4175 4.18125 8.5125 3.70875C9.6075 3.23625 10.77 3 12 3C13.245 3 14.415 3.23625 15.51 3.70875C16.605 4.18125 17.5575 4.8225 18.3675 5.6325C19.1775 6.4425 19.8188 7.395 20.2913 8.49C20.7638 9.585 21 10.755 21 12C21 13.23 20.7638 14.3925 20.2913 15.4875C19.8188 16.5825 19.1775 17.5388 18.3675 18.3563C17.5575 19.1737 16.605 19.8188 15.51 20.2913C14.415 20.7638 13.245 21 12 21Z"
          fill="#B3B3B3"
        />
      </svg>
    </span>
  )
}

const ClosedWalletBtnBarcode = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 6H4C2.89543 6 2 6.89543 2 8V20C2 21.1046 2.89543 22 4 22H24C25.1046 22 26 21.1046 26 20V8C26 6.89543 25.1046 6 24 6ZM4 4C1.79086 4 0 5.79086 0 8V20C0 22.2091 1.79086 24 4 24H24C26.2091 24 28 22.2091 28 20V8C28 5.79086 26.2091 4 24 4H4Z"
        fill="white"
      />
      <path
        d="M6 10.7059C6 10.316 6.31603 10 6.70588 10H7.29412C7.68397 10 8 10.316 8 10.7059V17.2941C8 17.684 7.68397 18 7.29412 18H6.70588C6.31603 18 6 17.684 6 17.2941V10.7059Z"
        fill="white"
      />
      <path
        d="M10 10.5C10 10.2239 10.2239 10 10.5 10C10.7761 10 11 10.2239 11 10.5V17.5C11 17.7761 10.7761 18 10.5 18C10.2239 18 10 17.7761 10 17.5V10.5Z"
        fill="white"
      />
      <path
        d="M13 10.7059C13 10.316 13.316 10 13.7059 10H14.2941C14.684 10 15 10.316 15 10.7059V17.2941C15 17.684 14.684 18 14.2941 18H13.7059C13.316 18 13 17.684 13 17.2941V10.7059Z"
        fill="white"
      />
      <path
        d="M17 10.5C17 10.2239 17.2239 10 17.5 10C17.7761 10 18 10.2239 18 10.5V17.5C18 17.7761 17.7761 18 17.5 18C17.2239 18 17 17.7761 17 17.5V10.5Z"
        fill="white"
      />
      <path
        d="M20 10.7059C20 10.316 20.316 10 20.7059 10H21.2941C21.684 10 22 10.316 22 10.7059V17.2941C22 17.684 21.684 18 21.2941 18H20.7059C20.316 18 20 17.684 20 17.2941V10.7059Z"
        fill="white"
      />
    </svg>
  )
}

const Reload = (props: { onClickFn?: any; size: '29' | '38' }) => {
  const { size, onClickFn } = props
  const size38 = size === '38'

  return (
    <section onClick={onClickFn}>
      {size38 ? (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          cursor="pointer"
        >
          <rect width="38" height="38" rx="10" fill="black" />
          <path
            d="M27.9389 19.7782C27.2452 19.6743 26.6291 20.1424 26.5296 20.8098C26.2798 22.4859 25.4939 24.0153 24.2569 25.233C21.1085 28.3323 15.9895 28.3298 12.8423 25.233C9.69581 22.135 9.69581 17.094 12.8423 13.9966C14.026 12.832 15.5202 12.0728 17.1925 11.7963C17.9117 11.662 18.6848 11.6388 19.4871 11.7283C20.5886 11.8531 21.6139 12.2128 22.5496 12.7411L20.9328 13.0128C20.2573 13.1269 19.8024 13.7584 19.9189 14.424C20.022 15.0197 20.5472 15.4405 21.1414 15.4405C21.2106 15.4405 21.2809 15.4351 21.3524 15.4231L25.6868 14.6937C26.0105 14.6388 26.3004 14.4597 26.4909 14.1946C26.6813 13.9302 26.7565 13.6018 26.7006 13.2819L25.9584 9.01579C25.8444 8.35087 25.2113 7.90552 24.5249 8.01713C23.8494 8.13119 23.3945 8.76334 23.511 9.42887L23.7064 10.5517C22.5043 9.88791 21.1784 9.45845 19.7696 9.29879C18.7145 9.18058 17.691 9.21346 16.7541 9.39011C14.5972 9.74586 12.6374 10.741 11.0862 12.2679C6.97126 16.3186 6.97126 22.9098 11.0862 26.9616C13.1436 28.9875 15.8469 30 18.5496 30C21.2529 30 23.9549 28.9877 26.013 26.9616C27.6297 25.3702 28.6581 23.3658 28.9867 21.1655C29.0863 20.497 28.6168 19.876 27.9389 19.7782Z"
            fill="#999999"
          />
        </svg>
      ) : (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5148 16.0768C21.9728 15.9956 21.4915 16.3613 21.4138 16.8826C21.2186 18.1921 20.6046 19.3869 19.6382 20.3383C17.1785 22.7596 13.1793 22.7577 10.7206 20.3383C8.26235 17.9179 8.26235 13.9797 10.7206 11.5598C11.6453 10.65 12.8126 10.0568 14.1191 9.84089C14.681 9.73593 15.285 9.71779 15.9118 9.7877C16.7724 9.88521 17.5734 10.1663 18.3043 10.579L17.0412 10.7913C16.5135 10.8804 16.1581 11.3738 16.2491 11.8937C16.3297 12.3591 16.74 12.6879 17.2042 12.6879C17.2583 12.6879 17.3132 12.6837 17.3691 12.6743L20.7553 12.1044C21.0082 12.0615 21.2347 11.9216 21.3835 11.7146C21.5322 11.508 21.591 11.2514 21.5474 11.0015L20.9675 7.66858C20.8784 7.14912 20.3838 6.80119 19.8476 6.88838C19.3199 6.97749 18.9645 7.47136 19.0555 7.9913L19.2081 8.86854C18.269 8.34993 17.2331 8.01441 16.1325 7.88968C15.3082 7.79733 14.5086 7.82302 13.7766 7.96103C12.0916 8.23895 10.5605 9.01638 9.3486 10.2093C6.1338 13.3739 6.1338 18.5233 9.3486 21.6888C10.956 23.2715 13.0679 24.0625 15.1794 24.0625C17.2913 24.0625 19.4022 23.2716 21.0102 21.6888C22.2732 20.4454 23.0766 18.8795 23.3333 17.1606C23.4111 16.6382 23.0444 16.1532 22.5148 16.0768Z"
            fill="#999999"
          />
        </svg>
      )}
    </section>
  )
}

const GrayX = (props: { onClickFn?: any; strokeWidth?: '2.4' | '1.6' }) => {
  const { onClickFn, strokeWidth } = props
  return (
    <section onClick={onClickFn}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 4L4.44365 19.5563"
          stroke="#E6E6E6"
          strokeWidth={strokeWidth || '2.4'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 4L19.5563 19.5563"
          stroke="#E6E6E6"
          strokeWidth={strokeWidth || '2.4'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </section>
  )
}

const GrayCircleX = (props: { onClickFn?: any; size: '16' | '24' }) => {
  const { onClickFn, size } = props
  return (
    <section onClick={onClickFn}>
      {size === '16' ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_8179_2447)">
            <path d="M13 3L3 13" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 3L13 13" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_8179_2447">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          onClick={onClickFn}
          cursor="pointer"
        >
          <path
            d="M8.625 16.32L12 12.945L15.375 16.32L16.32 15.375L12.945 12L16.32 8.625L15.375 7.68L12 11.055L8.625 7.68L7.68 8.625L11.055 12L7.68 15.375L8.625 16.32ZM12 21C10.77 21 9.6075 20.7638 8.5125 20.2913C7.4175 19.8188 6.46125 19.1737 5.64375 18.3563C4.82625 17.5388 4.18125 16.5825 3.70875 15.4875C3.23625 14.3925 3 13.23 3 12C3 10.755 3.23625 9.585 3.70875 8.49C4.18125 7.395 4.82625 6.4425 5.64375 5.6325C6.46125 4.8225 7.4175 4.18125 8.5125 3.70875C9.6075 3.23625 10.77 3 12 3C13.245 3 14.415 3.23625 15.51 3.70875C16.605 4.18125 17.5575 4.8225 18.3675 5.6325C19.1775 6.4425 19.8188 7.395 20.2913 8.49C20.7638 9.585 21 10.755 21 12C21 13.23 20.7638 14.3925 20.2913 15.4875C19.8188 16.5825 19.1775 17.5388 18.3675 18.3563C17.5575 19.1737 16.605 19.8188 15.51 20.2913C14.415 20.7638 13.245 21 12 21Z"
            fill="#B3B3B3"
          />
        </svg>
      )}
    </section>
  )
}

const BlueX = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7608_2538)">
        <g clipPath="url(#clip1_7608_2538)">
          <path d="M13 3L3 13" stroke="#0083FC" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 3L13 13" stroke="#0083FC" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7608_2538">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_7608_2538">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const BlackX = (props: { onClickFn?: any; size: '38' | '29' }) => {
  const { onClickFn, size } = props
  const size38 = size === '38'
  return (
    <section onClick={onClickFn}>
      {size38 ? (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          cursor="pointer"
        >
          <rect width="38" height="38" rx="10" fill="black" />
          <path
            d="M27 11L11.4437 26.5563"
            stroke="#E6E6E6"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 11L26.5563 26.5563"
            stroke="#E6E6E6"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.9375" y="0.625" width="29.6875" height="29.6875" rx="7.8125" fill="black" />
          <path
            d="M22.0312 9.21875L9.87785 21.3721"
            stroke="#E6E6E6"
            strokeWidth="1.875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.53125 9.21875L21.6846 21.3721"
            stroke="#E6E6E6"
            strokeWidth="1.875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </section>
  )
}

const DownLoad = (props: { color?: string }) => {
  const { color } = props
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.17139 7.82861L7.99982 11.657L11.8283 7.82861"
        stroke={color || '#B3B3B3'}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 11L8 3" stroke={color || '#B3B3B3'} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M3 14H13" stroke={color || '#B3B3B3'} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

const WhiteDownLoad = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M5.7356 9.54297L10.9997 14.8071L16.2638 9.54297"
        stroke="white"
        strokeWidth="1.83333"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11 13.9023L11 2.90234"
        stroke="white"
        strokeWidth="1.83333"
        strokeLinecap="square"
      />
      <path d="M4.125 18.0273H17.875" stroke="white" strokeWidth="1.83333" strokeLinecap="square" />
    </svg>
  )
}

const Check = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M7.19531 12.9579L11.5154 17.2776L18.7154 10.0781"
        stroke="white"
        strokeWidth="2.87991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const BlueCheck = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.5 4.72656L5.81989 12.4067L2 8.58679"
        stroke="#0083FC"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const BigCheck = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 6L9 17L4 12"
        stroke="#E6E6E6"
        stroke-width="3"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const Pin = (props: { color: string }) => {
  const { color } = props
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87209 14.1H3.97209V14.0919C4.73069 14.0657 5.43765 13.7417 5.97654 13.1692L11.1698 7.65168C11.1699 7.65156 11.1701 7.65143 11.1702 7.6513C11.5031 7.3042 11.6874 6.82951 11.6874 6.33619C11.6874 5.84213 11.5026 5.37426 11.1705 5.0214C10.484 4.29208 9.35922 4.29208 8.67276 5.0214L8.67272 5.02144L3.47881 10.546C3.4788 10.546 3.47878 10.5461 3.47877 10.5461C3.26722 10.7709 3.26723 11.1393 3.47881 11.364C3.69364 11.5923 4.05054 11.5923 4.26538 11.364L9.45933 5.84584C9.71613 5.57301 10.1271 5.57301 10.3839 5.84584L10.3839 5.84586L10.3854 5.84737C10.5107 5.97497 10.5805 6.15471 10.5805 6.34261C10.5805 6.52927 10.5115 6.70386 10.3839 6.83938L5.18997 12.3576C4.48584 13.1057 3.25881 13.1058 2.55452 12.3579C2.20308 11.9783 2.00698 11.4824 2.00698 10.9486C2.00698 10.4143 2.20346 9.91228 2.55421 9.53963L7.74817 4.02143C8.32867 3.40469 9.1008 3.0636 9.9186 3.0636C10.7364 3.0636 11.5085 3.40469 12.089 4.02143C12.6697 4.63836 12.993 5.46162 12.993 6.33619C12.993 7.21076 12.6697 8.03402 12.089 8.65095L8.66672 12.2869C8.45513 12.5117 8.45513 12.8801 8.66672 13.1049C8.88155 13.3332 9.23845 13.3332 9.45328 13.1049L12.8753 9.46925C12.8754 9.46919 12.8755 9.46912 12.8755 9.46906C13.6677 8.63385 14.1 7.5169 14.1 6.33619C14.1 5.15553 13.6678 4.03863 12.8756 3.20343C12.0893 2.36159 11.0353 1.9 9.9186 1.9C8.80191 1.9 7.74781 2.36162 6.96149 3.20353C6.96144 3.20358 6.96138 3.20364 6.96133 3.2037L1.76765 8.72161C1.20535 9.31901 0.9 10.1083 0.9 10.9486C0.9 11.789 1.20535 12.5782 1.76765 13.1756C2.33015 13.7732 3.07577 14.1 3.87209 14.1Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  )
}
const TopButtonArrow = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24995 2.73137L3.27995 6.96571C2.98744 7.27771 2.51191 7.27771 2.21939 6.96571C1.92687 6.65372 1.92687 6.14652 2.21939 5.83453L7.46972 0.234597C7.76223 -0.078199 8.23776 -0.078199 8.53028 0.234597L13.7806 5.83453C14.0731 6.14652 14.0731 6.65372 13.7806 6.96571C13.4881 7.27771 13.0126 7.27771 12.72 6.96571L8.75005 2.73137V15.2C8.75005 15.6416 8.41403 16 8 16C7.58597 16 7.24995 15.6416 7.24995 15.2V2.73137Z"
        fill="#808080"
      />
    </svg>
  )
}

const Location = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 6.72727C7.69182 6.72727 6.22727 8.19182 6.22727 10C6.22727 11.8082 7.69182 13.2727 9.5 13.2727C11.3082 13.2727 12.7727 11.8082 12.7727 10C12.7727 8.19182 11.3082 6.72727 9.5 6.72727ZM16.8145 9.18182C16.6292 7.52264 15.8852 5.9758 14.7047 4.7953C13.5242 3.61479 11.9774 2.87078 10.3182 2.68545V1H8.68182V2.68545C7.02264 2.87078 5.4758 3.61479 4.2953 4.7953C3.11479 5.9758 2.37078 7.52264 2.18545 9.18182H0.5V10.8182H2.18545C2.37078 12.4774 3.11479 14.0242 4.2953 15.2047C5.4758 16.3852 7.02264 17.1292 8.68182 17.3145V19H10.3182V17.3145C11.9774 17.1292 13.5242 16.3852 14.7047 15.2047C15.8852 14.0242 16.6292 12.4774 16.8145 10.8182H18.5V9.18182H16.8145ZM9.5 15.7273C6.33364 15.7273 3.77273 13.1664 3.77273 10C3.77273 6.83364 6.33364 4.27273 9.5 4.27273C12.6664 4.27273 15.2273 6.83364 15.2273 10C15.2273 13.1664 12.6664 15.7273 9.5 15.7273Z"
        fill="white"
      />
    </svg>
  )
}

const OpenWebsite = (props: { onClickFn?: any }) => {
  const { onClickFn } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClickFn}
    >
      <path
        d="M15.1111 19H7.33332C6.71002 19 6.12409 18.7573 5.6834 18.3165C5.24271 17.8758 5 17.2899 5 16.6667V8.88888C5 8.26562 5.24273 7.67968 5.68342 7.23899C6.12411 6.7983 6.71005 6.55556 7.33335 6.55556H10.4444C10.874 6.55556 11.2222 6.90377 11.2222 7.33335C11.2222 7.76292 10.874 8.11113 10.4444 8.11113H7.33332C7.12555 8.11113 6.93026 8.19204 6.78338 8.33892C6.6365 8.4858 6.55556 8.68112 6.55556 8.88888V16.6667C6.55556 16.8744 6.63648 17.0697 6.78338 17.2166C6.93026 17.3635 7.12555 17.4444 7.33332 17.4444H15.1111C15.3188 17.4444 15.5141 17.3635 15.661 17.2166C15.8079 17.0697 15.8888 16.8744 15.8888 16.6666V13.5556C15.8888 13.126 16.237 12.7778 16.6666 12.7778C17.0962 12.7778 17.4444 13.126 17.4444 13.5556V16.6667C17.4444 17.2899 17.2017 17.8758 16.761 18.3166C16.3203 18.7573 15.7343 19 15.1111 19ZM10.4444 14.3333C10.2454 14.3333 10.0463 14.2574 9.89448 14.1055C9.59075 13.8018 9.59075 13.3093 9.89448 13.0056L16.3444 6.55556H13.5556C13.126 6.55556 12.7778 6.20736 12.7778 5.77778C12.7778 5.3482 13.126 5 13.5556 5H18.2222C18.3298 5 18.4322 5.02184 18.5254 5.06132C18.6124 5.09811 18.6941 5.15142 18.7655 5.22127L18.7656 5.22132C18.7661 5.22184 18.7666 5.22233 18.7671 5.22284C18.7672 5.22298 18.7674 5.22314 18.7676 5.22328C18.7679 5.22366 18.7684 5.22407 18.7688 5.22447C18.769 5.22475 18.7693 5.22499 18.7695 5.22526C18.7698 5.22556 18.7702 5.22589 18.7704 5.22613C18.771 5.22668 18.7716 5.22725 18.7721 5.22782C18.7726 5.22836 18.7732 5.22896 18.7738 5.2295C18.7741 5.22977 18.7744 5.23013 18.7746 5.23037C18.7749 5.23064 18.7751 5.23089 18.7754 5.23116C18.7759 5.23157 18.7762 5.23195 18.7766 5.23238C18.7767 5.23249 18.7769 5.23268 18.777 5.23282C18.7776 5.23333 18.7781 5.23385 18.7786 5.23436L18.7786 5.23442C18.8484 5.30593 18.9018 5.3876 18.9385 5.47454C18.978 5.56773 18.9999 5.67016 18.9999 5.77776V10.4444C18.9999 10.874 18.6517 11.2222 18.2221 11.2222C17.7925 11.2222 17.4443 10.874 17.4443 10.4444V7.65552L10.9943 14.1055C10.8425 14.2574 10.6435 14.3333 10.4444 14.3333Z"
        fill="#808080"
      />
    </svg>
  )
}

const MapReFresh = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M0.833252 3.33325V8.33325H5.83325"
        stroke="#0083FC"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1666 16.6663V11.6663H14.1666"
        stroke="#0083FC"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0749 7.49974C16.6523 6.30539 15.934 5.23757 14.987 4.39592C14.0401 3.55427 12.8954 2.96621 11.6597 2.68662C10.424 2.40703 9.13762 2.44502 7.92059 2.79705C6.70356 3.14908 5.59554 3.80367 4.69992 4.69974L0.833252 8.33307M19.1666 11.6664L15.2999 15.2997C14.4043 16.1958 13.2963 16.8504 12.0792 17.2024C10.8622 17.5545 9.57584 17.5924 8.34016 17.3129C7.10447 17.0333 5.95975 16.4452 5.01281 15.6036C4.06586 14.7619 3.34756 13.6941 2.92492 12.4997"
        stroke="#0083FC"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

interface IconProps {
  onClickFn?: any
}

const FilterToggleDefault = (props: IconProps) => <FilterDefaultIcon onClick={props.onClickFn} />
const FilterToggleActive = (props: IconProps) => <FilterActiveIcon onClick={props.onClickFn} />
const ArrowBack = (props: IconProps) => <ArrowBackIcon onClick={props.onClickFn} />
const CurrentPosition = (props: IconProps) => <CurrentPositionIcon onClick={props.onClickFn} />
const Wastebasket = (props: IconProps) => <WasteBasketIcon onClick={props.onClickFn} />
const Noti = (props: IconProps) => <NotiIcon onClick={props.onClickFn} />
const RedNoti = (props: IconProps) => <NotiRedIcon onClick={props.onClickFn} />
const Share = (props: IconProps) => <ShareIcon onClick={props.onClickFn} />
const PlusCircle = (props: IconProps) => <PlusCircleIcon onClick={props.onClickFn} />
export const Icon = {
  Arrow,
  Search,
  ClosedWalletBtnBarcode,
  Reload,
  MapReFresh,
  GrayX,
  GrayCircleX,
  TopButtonArrow,
  OpenWebsite,
  BlackX,
  DownLoad,
  WhiteDownLoad,
  Check,
  BlueCheck,
  BigCheck,
  Pin,
  Noti,
  RedNoti,
  BlueX,
  Location,
  FilterToggleDefault,
  FilterToggleActive,
  ArrowBack,
  CurrentPosition,
  Wastebasket,
  Share,
  PlusCircle,
  FillRoundCancle,
}
